import { isSameDay } from 'date-fns';
import { CalendarEvent } from '../useCalendar/types';

export const getFirstItemOfArray = (array: any[]) => array[0]
export const getLastItemOfArray = (array: any[]) => array[array.length - 1]

export const clamp = (min: number, max: number, value: number) => {
  if (value > max) {
    return max;
  } if (value < min) {
    return min;
  }
  return value;
}


export const parseTypescriptObjectToJSObject = (obj: any) => JSON.parse(JSON.stringify(obj))


export const getEventsDateMap = (visibleDays: Date[], events?: CalendarEvent[]) => {
  if (!events) {
    return {};
  }

  const map = new Map<Date, CalendarEvent[]>()
  for (let i = 0; i < visibleDays.length; i++) {
    const currentVisibleDay = visibleDays[i]
    // eslint-disable-next-line no-loop-func
    map.set(currentVisibleDay, events.filter((event: CalendarEvent) => isSameDay(event.date, currentVisibleDay)))
  }

  return map
}

export const listToMatrix = (list: any[], elementsPerSubArray: number) => {
  const matrix: any[] = [];
  let i;
  let k;

  for (i = 0, k = -1; i < list.length; i++) {
    if (i % elementsPerSubArray === 0) {
      k++;
      matrix[k] = [];
    }

    matrix[k].push(list[i]);
  }

  return matrix;
}
